
import React from 'react'

const Home = () => {
    return (
        <div>
            <div>Home</div>
        </div>
    )
}

export default Home